import CandidatosDemandas from "../components/CandidatosDemandas";
//import CandidatosTransparencia from "./components/CandidatosTransparencia";
//import CandidatosCorrupcion from "./components/CandidatosCorrupcion";
import { useState } from "react";

import Map from "../components/general/Map";


const dataRegions = [
  {
    id: "PE-AMA",
    name: "Amazonas",
    value: 27,
  },
  {
    id: "PE-ANC",
    name: "Áncash",
    value: 7,
  },
  {
    id: "PE-APU",
    name: "Apurímac",
    value: 6,
  },
  {
    id: "PE-ARE",
    name: "Arequipa",
    value: 9,
  },
  {
    id: "PE-AYA",
    name: "Ayacucho",
    value: 8,
  },
  {
    id: "PE-CAJ",
    name: "Cajamarca",
    value: 8,
  },
  {
    id: "PE-CAL",
    name: "Callao",
    value: 41,
  },
  {
    id: "PE-CUS",
    name: "Cusco",
    value: 10,
  },
  {
    id: "PE-HUV",
    name: "Huancavelica",
    value: 6,
  },
  {
    id: "PE-HUC",
    name: "Huánuco",
    value: 2,
  },
  {
    id: "PE-ICA",
    name: "Ica",
    value: 5,
  },
  {
    id: "PE-JUN",
    name: "Junín",
    value: 5,
  },
  {
    id: "PE-LAL",
    name: "La Libertad",
    value: 10,
  },
  {
    id: "PE-LAM",
    name: "Lambayeque",
    value: 13,
  },
  {
    id: "PE-LMA",
    name: "Lima metropolitana",
    value: 49,
  },
  {
    id: "PE-LIM",
    name: "Lima región",
    value: 13,
  },
  {
    id: "PE-LOR",
    name: "Loreto",
    value: 21,
  },
  {
    id: "PE-MDD",
    name: "Madre de Dios",
    value: 6,
  },
  {
    id: "PE-MOQ",
    name: "Moquegua",
    value: 1,
  },
  {
    id: "PE-PAS",
    name: "Pasco",
    value: 5,
  },
  {
    id: "PE-PIU",
    name: "Piura",
    value: 15,
  },
  {
    id: "PE-PUN",
    name: "Puno",
    value: 5,
  },
  {
    id: "PE-SAM",
    name: "San Martín",
    value: 8,
  },
  {
    id: "PE-TAC",
    name: "Tacna",
    value: 2,
  },
  {
    id: "PE-TUM",
    name: "Tumbes",
    value: 11,
  },
  {
    id: "PE-UCA",
    name: "Ucayali",
    value: 8,
  },
];


const App = () => {
  const [currentRegion, setCurrentRegion] = useState(null);

  return (
    <div className="App">
      <div>
     
        <div className="px-md-5 px-3">
        <h1 className="mt-5 pt-2 pb-1">
            Buscador de jueces y fiscales sancionados
            </h1>
            <p className="bajada">Explora nuestro mapa interactivo para identificar a jueces y fiscales sancionados por la Junta Nacional de Justicia en cada región del Perú.</p>
          <div className="row align-items-start">
          <div className="col-md-4 col-xs-12 pt-5">
              <Map data={dataRegions} setCurrentRegion={setCurrentRegion} />
            </div>
            <div className="col-md-8 col-xs-12">
              <div id="candidatos">
              
                  <div id="candidatos-demandas">
                    <CandidatosDemandas currentRegion={currentRegion} />
                  </div>
              
              </div>
            </div>
           
          </div>
        </div>
      </div>
    </div>
  );
};

export default App;
